import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { DragDropContext } from 'react-beautiful-dnd';
import { useParams } from 'react-router-dom';
import { CampaignContext } from '../../../../contexts/CampaignContext';
import axiosService from '../../../../utils/AxiosService';
import { toastSuccess } from '../../../FormComponents/Toasts';
import FileList from './FilesParts/FileList';
import FilenameSearch from './FilesParts/FilenameSearch';
import Folders from './FilesParts/Folders';
import TypeSearch from './FilesParts/TypeSearch';

export default observer(function Files() {
  const { id, campaign_folder_id } = useParams()
  const { campaignFolders, documents, loadDocuments } = useContext(CampaignContext)

  const handleDragEnd = ({ source, destination, draggableId }) => {
    if(+destination?.droppableId === +campaign_folder_id) return toastSuccess('The document is already in that folder')

    if (source && destination && destination.droppableId !== 'files') {
      axiosService.patch(`/api/project_manager/campaigns/${id}/documents/${draggableId}/move_to_folder/${destination.droppableId}`)
      .then(document => {
        const oldDocument = documents.find(document => document.id === +draggableId)
        if(oldDocument.campaign_folder_id) campaignFolders.find(campaignFolder => campaignFolder.id === oldDocument.campaign_folder_id).documents_count -= 1

        campaignFolders.find(campaignFolder => campaignFolder.id === document.campaign_folder_id).documents_count += 1
        toastSuccess('Document moved')
        loadDocuments()
      })
    }
  }
  return (
    <div className="pt-8 p-4 dark:bg-rb-dark-mode-background">
      <div className="flex items-center gap-4 mb-4">
        <FilenameSearch />
        <TypeSearch />
      </div>

      <DragDropContext onDragEnd={handleDragEnd}>
        <Folders />
        <FileList />
      </DragDropContext>
    </div>
  )
})